export default "__VITE_ASSET__CWxRkMuw__"